import { DefaultDependentField } from './constants';
const createDependentField = args => Object.assign({}, DefaultDependentField, args);
export default createDependentField;